import React from 'react';
import _ from 'underscore';
import {
  BillingDocumentCell,
  AmountCell,
  ChangeTypeCell,
  AmountTotalCell,
  InsertionOrderDetailsCell,
  getBudgetChangeString,
  ChangeTypeEnum,
} from '@bingads-webui-campaign/reports-v4-component';
import { isInsertionOrderMonthlyView, isInsertionOrderReport, shouldDisplayTotalAmount } from './insertion-order-helper';
import { isNormalRow, isTotalRow } from './row-helper';

export function bindOnRenderRowsForInsertionOrderReport({
  i18n, item, column, reportType, permissions, viewType, isAccountScope, filters,
}) {
  if (!isInsertionOrderReport({ reportType, permissions })) {
    return null;
  }

  const isMonthlyView = isInsertionOrderMonthlyView({ reportType, permissions, viewType });
  const isNormal = isNormalRow(item);

  if (isMonthlyView && isNormal && column.key === 'ChangeType') {
    const {
      SpendTypeValue, AdjustmentTypeValue, BudgetChangedTypeValue,
      WithBudgetChangeDescription,
    } = item;
    return (
      <ChangeTypeCell
        spend={SpendTypeValue}
        adjustment={AdjustmentTypeValue}
        budgetChange={BudgetChangedTypeValue}
        withBudgetChangeDescription={WithBudgetChangeDescription}
      />
    );
  }
  if (isNormal && column.key === 'ChangeAmount') {
    const {
      SpendAmountValue, AdjustmentAmountValue, BudgetChangedAmountValue,
      BudgetChangeOldValue, BudgetChangeNewValue, WithBudgetChangeDescription,
    } = item;
    return (
      <AmountCell
        i18n={i18n}
        spendAmount={_.get(SpendAmountValue, 'Value', undefined)}
        adjustmentAmount={_.get(AdjustmentAmountValue, 'Value', undefined)}
        budgetChangeAmount={_.get(BudgetChangedAmountValue, 'Value', undefined)}
        withBudgetChangeDescription={WithBudgetChangeDescription}
        budgetChangeOldValue={_.get(BudgetChangeOldValue, 'Value', undefined)}
        budgetChangeNewValue={_.get(BudgetChangeNewValue, 'Value', undefined)}
        spendRawValue={_.get(SpendAmountValue, 'RawValue', undefined)}
        adjustmentRawValue={_.get(AdjustmentAmountValue, 'RawValue', undefined)}
        budgetChangeRawValue={_.get(BudgetChangedAmountValue, 'RawValue', undefined)}
        budgetChangeOldValueRawValue={_.get(BudgetChangeOldValue, 'RawValue', undefined)}
        budgetChangeNewValueRawValue={_.get(BudgetChangeNewValue, 'RawValue', undefined)}
      />
    );
  }
  if (isNormal && column.key === 'BillingDocumentNumber') {
    const {
      BillingDocumentNumber, MismatchedAmount, MismatchedReason, CurrencyCode,
    } = item;
    return (
      <BillingDocumentCell
        i18n={i18n}
        billingDocumentNumbers={_.get(BillingDocumentNumber, 'Value', '').split(',')}
        mismatchedAmount={_.get(MismatchedAmount, 'RawValue', undefined)}
        mismatchedReason={_.get(MismatchedReason, 'Value', undefined)}
        currencyCode={_.get(CurrencyCode, 'Value', undefined)}
      />
    );
  }
  if (isNormal && column.key === 'InsertionOrderDetails') {
    const {
      InsertionOrderDetails, InsertionOrderId, AccountId,
    } = item;
    return (
      <InsertionOrderDetailsCell
        insertionOrderDetailValue={_.get(InsertionOrderDetails, 'Value', undefined)}
        insertionOrderId={_.get(InsertionOrderId, 'Value', undefined)}
        accountId={_.get(AccountId, 'Value', undefined)}
      />
    );
  }
  if (column.key === 'ChangeAmount' && isTotalRow(item)) {
    if (!isAccountScope) {
      return (<div />); // In customer level, the currency code is not same, so hide the total amount
    }
    const {
      SpendAmount, AdjustmentAmount, BudgetChangedAmount,
    } = item;
    return (
      <AmountTotalCell
        i18n={i18n}
        totalSpendAmount={shouldDisplayTotalAmount({ filters, changeType: ChangeTypeEnum.Spend }) && SpendAmount}
        totalAdjustmentAmount={shouldDisplayTotalAmount({ filters, changeType: ChangeTypeEnum.SystemAdjustment }) && AdjustmentAmount}
        totalBudgetChangeAmount={shouldDisplayTotalAmount({ filters, changeType: ChangeTypeEnum.BudgetChange }) && BudgetChangedAmount}
        withPadding={isInsertionOrderReport({ reportType, permissions, viewType })}
      />
    );
  }
  if (isNormal && column.key === 'RemainingIOBudget') {
    const { RemainingIOBudget } = item;
    if (!RemainingIOBudget) {
      return (<div />);
    }
    const remainingIOBudgetString = getBudgetChangeString({
      i18n,
      rawValue: RemainingIOBudget.RawValue,
      amountValue: RemainingIOBudget.Value,
      useEmptyString: false,
    });
    return (<span className="remaining-io-budget-cell">{remainingIOBudgetString}</span>);
  }
  if (column.key === 'RemainingIOBudget' && isTotalRow(item)) {
    return (<div />);
  }
  return null;
}
